<ng-template #spinner>
    <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<div class="recipient" [formGroup]="scheduleReport.scheduleForm">
    <h3 color="primary">Recipients</h3>
    <div *ngIf="recipient$ | async else spinner" formArrayName="recipients">
        <div *ngFor="let res of recipientArray.controls; let i=index" [formGroupName]="i">
            <div class="two-row">
                <div class="group">
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput placeholder="Name" formControlName="recipient_name" [required]="false"
                            [matAutocomplete]="autoname" (blur)="addRecipient(i)" (click)="manageFormArrayValues(i)" />
                        <mat-error libInputErrors [control]="scheduleReport.scheduleForm.get('recipient_name')"></mat-error>
                    </mat-form-field>
                    <mat-autocomplete #autoname="matAutocomplete">
                        <mat-option *ngFor="let nm of rnameFiltered$[i] | async" [value]="nm"
                            (click)="addRecipient(i)">{{nm}}</mat-option>
                    </mat-autocomplete>


                </div>

                <div class="group">
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput email type="email" name="email" placeholder="Email" formControlName="recipient_email"
                            [required]="recipientRequired(i)" [matAutocomplete]="autoemail" (blur)="addRecipient(i)"
                            (click)="manageFormArrayValues(i)" />
                        <mat-error *ngIf="recipientArray.at(i).get('recipient_email').errors">
                            <span *ngIf="recipientArray.at(i).get('recipient_email').errors.required">Required</span>
                            <span *ngIf="recipientArray.at(i).get('recipient_email').errors.pattern">Invalid Email</span>
                            <span *ngIf="recipientArray.at(i).get('recipient_email').errors.duplicated">Email Duplicate</span>
                        </mat-error>
                    </mat-form-field>

                    <mat-autocomplete #autoemail="matAutocomplete">
                        <mat-option *ngFor="let em of remailFiltered$[i] | async" [value]="em"
                            (click)="addRecipient(i)">{{em}}</mat-option>
                    </mat-autocomplete>


                    <button mat-icon-button *ngIf="i != (recipientArray.length - 1)" color="warn"
                        (click)="removeRec(i)">
                        <mat-icon matTooltip="Remove">close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>